import React, { useState, useRef } from "react";
import bg from "../img/banner-bg.png";
import "./Calendar.css";
import emailjs from '@emailjs/browser';
import { toast } from "react-hot-toast";

const Banner = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [bannerFormData, setBannerFormData] = useState({
    name: "",
    email: "",
    phone: ""
  });
  const [isSubmittingBannerForm, setIsSubmittingBannerForm] = useState(false);
  
  // Banner form reference for EmailJS
  const bannerForm = useRef();

  const handleBannerInputChange = (e) => {
    const { id, value } = e.target;
    setBannerFormData({
      ...bannerFormData,
      [id === 'banner-name' ? 'name' : 
       id === 'banner-email' ? 'email' : 
       id === 'banner-phone' ? 'phone' : id]: value
    });
  };

  const handleBannerSubmit = (e) => {
    e.preventDefault();
    setIsSubmittingBannerForm(true);
    
    emailjs.sendForm('service_t8cc8t8', 'template_rbls5lj', bannerForm.current, process.env.REACT_APP_EMAILJS_PUBLIC_API)
      .then((result) => {
        console.log("Banner form EmailJS response:", result);
        setIsSubmittingBannerForm(false);
        if (result.status === 200) {
          toast.success(
            "Thank you for your message! We'll get back to you soon.",
            { id: 'banner-form' }
          );
          // Reset the form
          setBannerFormData({
            name: "",
            email: "",
            phone: ""
          });
          e.target.reset();
        }
      }, (error) => {
        console.error("Banner form EmailJS error:", error);
        setIsSubmittingBannerForm(false);
        toast.error("Something went wrong! Please try again.", { id: 'banner-form' });
      });
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const renderCalendarStep = () => {
    return (
      <div className="google-calendar-container">
        <h2 className="calendar-title">Exclusive Consultation</h2>
        <p className="calendar-subtitle">Select a convenient time for your complimentary strategy session with our virtual kitchen specialists</p>
        <div className="google-calendar-wrapper">
          <iframe 
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3bx6kbQqtu-wVjgCL2H26Z16mSbWqgSAt5J-bVWbFdx6o_jy0Knt21nnGAvFeQfaJpx7LtZld7?gv=true" 
            width="100%" 
            height="600" 
            frameBorder="0"
            title="Book a consultation"
          ></iframe>
        </div>
      </div>
    );
  };

  const renderPopupContent = () => {
    // Only render the Google Calendar booking interface
    return renderCalendarStep();
  };

  return (
    <>
      <section
        className="banner-section"
        style={{ background: `url(${bg}) no-repeat center center / cover` }}
      >
        <div className="container">
          <div className="banner-wrapper">
            <div className="banner-content">
              <span className="line"></span>
              <h1 className="title">
                Add A Virtual Brand To Your Restaurant Kitchen
              </h1>
              <p>Increase your restaurant profit without increasing your costs.</p>

              {/* Open Pop-up Button */}
              <button onClick={() => setShowPopup(true)} className="cmn-btn luxury-btn">
                <span>Book a Free Consultation</span>
              </button>
            </div>

            <div className="banner-form bg--title">
              <div className="text-center">
                <h5 className="text--base">We want to hear from you</h5>
                <p>Send us your details and we'll get back to you to schedule a time to talk.</p>
              </div>
              <form ref={bannerForm} onSubmit={handleBannerSubmit}>
                <div className="form-group">
                  <label className="form-label" htmlFor="banner-name">Name</label>
                  <input 
                    required 
                    name="Name" 
                    className="form-control-2" 
                    type="text" 
                    id="banner-name" 
                    value={bannerFormData.name}
                    onChange={handleBannerInputChange}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="banner-email">Email</label>
                  <input 
                    required 
                    name="Email Address" 
                    className="form-control-2" 
                    type="email" 
                    id="banner-email" 
                    value={bannerFormData.email}
                    onChange={handleBannerInputChange}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="banner-phone">Phone</label>
                  <input 
                    required 
                    name="Phone Number" 
                    className="form-control-2" 
                    type="text" 
                    id="banner-phone" 
                    value={bannerFormData.phone}
                    onChange={handleBannerInputChange}
                  />
                </div>
                {/* Hidden message field to ensure EmailJS receives all expected fields */}
                <input 
                  type="hidden" 
                  name="Message" 
                  value="Contact request from homepage banner"
                />
                <div className="text-center pt-3">
                  <button 
                    type="submit" 
                    className="cmn-btn"
                    disabled={isSubmittingBannerForm}
                  >
                    <span>{isSubmittingBannerForm ? "Sending..." : "Send"}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      
      {/* Google Calendar Appointment Popup */}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={closePopup}>&times;</span>
            {renderPopupContent()}
          </div>
        </div>
      )}
    </>
  );
};

export default Banner;